var path = '/modules/media/views/modals/media-selector-modal.tpl.html';
var html = "<button class=\"close\" ng-click=\"vm.dismiss()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n    <h2>Select file</h2>\n</div>\n<div class=\"modal-body\">\n    <al-media-manager\n            enable-file-selection=\"true\"\n            on-file-selection=\"vm.handleFileSelection(file)\"\n            current-directory=\"vm.startDirectory\"\n            pre-selected-file-uuid=\"vm.preSelectedFile\"\n    ></al-media-manager>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/media/views/modals/media-selector-modal.tpl.html
// module id = 502
// module chunks = 1